import { Route, Switch } from 'wouter';

import { Footer } from './components/Footer';
import { Create } from './pages/Create';
import { Expired } from './pages/Expired';
import { Landing } from './pages/Landing';
import { MyPolls } from './pages/MyPolls';
import { NotFound } from './pages/NotFound';
import { Poll } from './pages/Poll';

export function App() {
  return (
    <div className="app-shell">
      <Switch>
        <Route path="/" component={Landing} />
        <Route path="/new" component={Create} />
        <Route path="/me" component={MyPolls} />
        <Route path="/expired" component={Expired} />
        <Route path="/p/:pollId">{(params) => <Poll pollId={params.pollId} />}</Route>
        <Route component={NotFound} />
      </Switch>
      <Footer />
    </div>
  );
}
